import React from 'react';
import r2wc from '@r2wc/react-to-web-component';
import AttentionBling, {
  AttentionBlingProps,
} from 'src/components/AttentionBling/AttentionBling';

export const AttentionBlingWrapper: React.FC<AttentionBlingProps> = (props) => {
  return <AttentionBling {...props} />;
};

const AttentionBlingComponent = r2wc(AttentionBlingWrapper, {
  props: {
    id: 'string',
    tooltipText: 'string',
  },
});
export default AttentionBlingComponent;
